import React, { FC } from 'react';
import AssetNumberDisplay from '../components/asset_row_display/AssetNumberDisplay';

const AssetFilterRowDisplay: FC<any> = ({ asset }): React.ReactElement => {
	const displayId = asset.buyerSpecificAssetId || asset.id;
	return (
		<div className="space-between flex flex-col">
			<div className="space-between flex w-full flex-row items-center justify-between">
				<div className="flex max-w-[80%] flex-row flex-wrap whitespace-normal break-words">
					{asset.name}
				</div>
				<AssetNumberDisplay asset={asset} />
			</div>
			<div className="flex flex-row items-center gap-2">
				<div className="text-gray-400">&nbsp;{`ID ${displayId}`}</div>
				{asset.serialNumber && (
					<div className="text-gray-400">&nbsp;{`Serial ${asset.serialNumber}`}</div>
				)}
			</div>
		</div>
	);
};

export default AssetFilterRowDisplay;
